import { IGoodCard } from '../model/IGood';

export const isExpress = (good: IGoodCard) => {
  return good?.labels && good.labels.find((good) => good.code === 'EXPRESS-DELIVERY')?.active;
};
